import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { useNavigationHooks } from "..";
import { useViewActions } from "../../store";
import { INotification, UrlQueryParams } from "../../store/types";
import { JSON_to_URLEncoded } from "../../utils";
import { NotificationHandlerType } from "./use-click-handler";

export function useCommentHandle(): NotificationHandlerType {
  const { commentsScrollAction } = useViewActions();
  const { getFormPathName } = useNavigationHooks();
  const { push } = useHistory();

  return useCallback(async ({ components }: INotification) => {
    const searchObj: UrlQueryParams = {
      section: components.section_id,
      bar: "comments"
    };

    if (!components.form_id) return;

    if (components.type === "deleted") {
      push({
        pathname: getFormPathName(components.deal_id, components.form_id),
        search: JSON_to_URLEncoded(searchObj)
      });
    } else {
      if (components.question_uuid) {
        searchObj["question-uuid"] = components.question_uuid;
      }
      searchObj.comment = components.comment_id;
      push({
        pathname: getFormPathName(components.deal_id, components.form_id),
        search: JSON_to_URLEncoded(searchObj)
      });
      commentsScrollAction(true);
    }
  }, []);
}
